// removed by extract-text-webpack-plugin
module.exports = {"noScroll":"overlayView__noScroll__fd76dd6c","body":"overlayView__body__fd76dd6c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/OverlayView/overlayView.scss
// module id = ./src/components/MobileNav/OverlayView/overlayView.scss
// module chunks = 4